import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Card from '../../Card';

const TutorialList = ({ datas }) => {
  return (
    <Container fluid className="help-info bg-light ">
      <Row className="py-3 mb-3">
        {!!datas?.length &&
          datas.map((news) => (
            <Col md={4} key={news.id} className="text-center">
              <Card className="h-100">
                <Card.Body className="content-wrapper mb-2 d-flex flex-column">
                  <Card.Img
                    className="mb-4 mt-2"
                    src={
                      news?.attributes?.banner?.data?.attributes?.formats?.thumbnail
                        ?.url
                    }
                    alt={
                      news?.attributes?.banner?.data?.attributes?.formats?.thumbnail
                        ?.name
                    }
                    style={{ width: '365px', height: '180px', objectFit: 'cover' }}
                  />
                  <Card.Title
                    style={{
                      minHeight: '4em',
                      overflow: 'hidden',
                      maxHeight: '5em',
                    }}
                  >
                    <div className="text-truncate-multiline text-left">
                      {news.attributes.title}
                    </div>
                  </Card.Title>
                  <Card.Text className="text-truncate-multiline mb-4 text-left">
                    <div
                      style={{
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                      }}
                    >
                      {news.attributes.short_intro}
                    </div>
                  </Card.Text>
                </Card.Body>
                <div className="d-flex justify-content-end pr-3">
                  <a
                    className="btn btn-primary"
                    href={`https://www.printcart.com/tutorial/${news.attributes.alias}`}
                    rel="noopener noreferrer"
                    style={{ width: '150px' }}
                  >
                    View Detail
                  </a>
                </div>
              </Card>
            </Col>
          ))}
      </Row>
    </Container>
  );
};

export default TutorialList;
